import { render } from "./IconBolt.vue?vue&type=template&id=4942112a"
import script from "./IconBolt.vue?vue&type=script&lang=js"
export * from "./IconBolt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__